import inject from "scripts/ioc/inject";
import BaseView from "scripts/views/baseView";
import templateFooter from "templates/footer.hbs";
import { getFooterLogoOption } from "scripts/utils/whiteLabelUtil";

class FooterView extends BaseView {
  get template() {
    return templateFooter;
  }

  constructor(
    options,
    selfEService = inject("selfEService"),
    securityService = inject("securityService"),
  ) {
    super(options);

    this.selfEService = selfEService;
    this.securityService = securityService;
  }

  render() {
    const user = this.securityService.getUser();

    this.$el.html(
      this.template({
        showSelfe: this.selfEService.getShowSelfE(),
        pressbooksUrl: user.getActiveOrganizationProperty("pressbooksUrl"),
        generalSelfEUrl: this.selfEService.getGeneralSelfEUrl(),
        partnerSelfEUrl: this.selfEService.getPartnerSelfEUrl(),
        logo: getFooterLogoOption(
          user.getActiveOrganizationDynamicProperty("footerLogo"),
        ),
        pledgeUrl: user.getActiveOrganizationDynamicProperty("pledgeUrl"),
        platformTitle: user.getActiveOrganizationDynamicProperty("platformTitle"),
        orgSupportEmail: user.getActiveOrganizationDynamicProperty(
          "supportEmail",
        ),
        blogUrl: user.getActiveOrganizationDynamicProperty("blogUrl"),
        orgInfoEmail: user.getActiveOrganizationDynamicProperty("infoEmail"),
        externalAboutPageUrl: user.getActiveOrganizationDynamicProperty(
          "aboutPageUrl",
        ),
        twitterUrl: user.getActiveOrganizationDynamicProperty("twitterUrl"),
        showLegalNotices:
          user.getActiveOrganizationDynamicProperty("hideLegalNotices") !== "1",
        showAppLogos:
          process.env.PATRON_UI_SHOW_APP_LOGOS &&
          !user.getActiveOrganizationDynamicProperty("twitterUrl"),
      }),
    );

    return this;
  }
}

export default FooterView;
